<h5>{{ 'contact.places' | translate }}</h5>

<div class="contact-places-container">

  <div fxLayout="row wrap">

    <!-- Ogni place in una card -->
    <div fxFlex="33.33" fxFlex.sm="100" fxFlex.md="100" fxFlex.xs="100" 
         *ngFor="let configuration of configurations; let idx = index;">

      <app-contact-place [configuration]="configuration" [idx]="idx + 1"></app-contact-place>

    </div>

    <!-- Pulsante per aggiungere un nuovo place -->
    <div fxFlex="33.33" fxFlex.sm="100" fxFlex.md="100" fxFlex.xs="100">

      <mat-card class="add-button" (click)="addNewConfiguration()">

        <mat-card-content>

          <button mat-fab color="primary">

            <mat-icon>add</mat-icon>

          </button>

        </mat-card-content>

      </mat-card>

    </div>

  </div>

</div>
